/**
 * Custom Tarps Pricing Engine
 * Handles dynamic price calculation, variant selection for bestseller sizes,
 * and accessory costs based on the selected fabric, weight/thickness/shade factor,
 * dimensions, and accessories.
 */
(function () {
  var configEl = document.getElementById('customTarpsConfigJson');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    console.error('Pricing engine failed to parse custom tarps config:', e);
    var posMatch = e.message.match(/position (\d+)/);
    if (posMatch) {
      var pos = parseInt(posMatch[1], 10);
      var start = Math.max(0, pos - 80);
      var end = Math.min(configEl.textContent.length, pos + 80);
      console.error('Pricing JSON Error Snippet near position ' + pos + ':\n...' + configEl.textContent.slice(start, end) + '...');
    }
    return;
  }
  if (!config.weights || !config.accessories) return;

  var accessories = config.accessories || {};
  var webbingPerSqFt = !isNaN(Number(accessories.webbingPerSqFt)) ? Number(accessories.webbingPerSqFt) : 0.07;
  var dRings24PerFt = !isNaN(Number(accessories.dRings24PerLinearFt)) ? Number(accessories.dRings24PerLinearFt) : 1.62;
  var dRings12PerFt = !isNaN(Number(accessories.dRings12PerLinearFt)) ? Number(accessories.dRings12PerLinearFt) : 2.12;

  function getSelectedFabricId() {
    var r = document.querySelector('.custom-tarps-fabric-radio:checked');
    return r ? r.getAttribute('data-fabric-id') : null;
  }

  function getCurrentWeights() {
    var fabricId = getSelectedFabricId();
    if (!fabricId) return [];
    return config.weights[fabricId] || [];
  }

  function getSelectedWeightId() {
    var r = document.querySelector('.custom-tarps-weight-radio:checked:not(:disabled)');
    if (r) return r.getAttribute('data-weight-id');
    var weights = getCurrentWeights();
    return weights[0] ? weights[0].id : null;
  }

  function getSelectedWeightLabel() {
    var w = getWeightConfig(getSelectedWeightId());
    return w ? w.label : '';
  }

  function getSelectedColorId() {
    var r = document.querySelector('.custom-tarps-color-radio:checked:not(:disabled)');
    if (!r) return '';
    var option = r.closest('.custom-tarps-color-option');
    return option ? option.getAttribute('data-color-id') : '';
  }

  function getSelectedColorLabel() {
    var r = document.querySelector('.custom-tarps-color-radio:checked:not(:disabled)');
    return r ? r.value : '';
  }

  function getSelectedFastener() {
    var r = document.querySelector('.custom-tarps-fastener-radio:checked, .custom-tarps-grommet-radio:checked');
    if (!r) {
      return null;
    }
    var type = r.getAttribute('data-fastener-type');
    if (!type) {
      type = (r.id && r.id.indexOf('dring') !== -1) ? 'drings' : 'grommets';
    }
    var spacing = r.getAttribute('data-spacing');
    if (!spacing) {
      if (r.id && r.id.indexOf('12') !== -1) spacing = '12';
      else if (r.id && r.id.indexOf('6') !== -1) spacing = '6';
      else spacing = '24';
    }
    return {
      element: r,
      type: type,
      spacing: spacing,
      value: r.value || ''
    };
  }

  function getGrommetKey() {
    var fastener = getSelectedFastener();
    if (!fastener) return 'grommet24';
    if (fastener.type === 'drings') return 'grommet24';
    if (fastener.spacing === '12') return 'grommet12';
    if (fastener.spacing === '6') return 'grommet6';
    return 'grommet24';
  }

  function getWeightConfig(weightId) {
    var weights = getCurrentWeights();
    for (var i = 0; i < weights.length; i++) {
      if (weights[i].id === weightId) return weights[i];
    }
    return weights[0];
  }

  function getPricePerSqFt(weightId, grommetKey, colorId) {
    var w = getWeightConfig(weightId);
    if (!w) return 0;

    var selectedSubRadio = document.querySelector('.custom-tarps-subweight-radio:checked:not(:disabled)');
    if (selectedSubRadio) {
      var keyMap = { grommet24: 'grommet-24', grommet12: 'grommet-12', grommet6: 'grommet-6' };
      var attrVal = selectedSubRadio.getAttribute('data-' + keyMap[grommetKey]);
      if (attrVal !== null && attrVal !== undefined && attrVal !== '') {
        var subPrice = parseFloat(attrVal);
        if (!isNaN(subPrice) && subPrice > 0) {
          return subPrice;
        }
      }
      if (w.subVariations && w.subVariations.length) {
        var subId = selectedSubRadio.getAttribute('data-subweight-id');
        var subObj = w.subVariations.find(function (s) { return s.id === subId; });
        if (subObj && subObj.pricePerSqFt) {
          return Number(subObj.pricePerSqFt[grommetKey]) || 0;
        }
      }
    }

    if (!w.pricePerSqFt) return 0;
    if (w.camoColorId && w.camoPricePerSqFt && colorId === w.camoColorId) {
      return Number(w.camoPricePerSqFt[grommetKey]) || 0;
    }
    return Number(w.pricePerSqFt[grommetKey]) || 0;
  }

  function getVariantSelector() {
    return document.getElementById('customTarpsVariantSelector');
  }

  function getCustomSizeVariantId() {
    var sel = getVariantSelector();
    return sel ? sel.getAttribute('data-custom-size-variant-id') : null;
  }

  function getDimensions() {
    var lengthFeetEl = document.getElementById('lengthFeet');
    var lengthInchEl = document.getElementById('lengthInch');
    var widthFeetEl = document.getElementById('widthFeet');
    var widthInchEl = document.getElementById('widthInch');
    var lengthFt = parseFloat(lengthFeetEl && lengthFeetEl.value) || 0;
    var lengthIn = parseFloat(lengthInchEl && lengthInchEl.value) || 0;
    var widthFt = parseFloat(widthFeetEl && widthFeetEl.value) || 0;
    var widthIn = parseFloat(widthInchEl && widthInchEl.value) || 0;
    var calcLengthFt = lengthIn > 0 ? (lengthFt + 1) : lengthFt;
    var calcWidthFt = widthIn > 0 ? (widthFt + 1) : widthFt;
    return {
      lengthFt: lengthFt,
      lengthIn: lengthIn,
      widthFt: widthFt,
      widthIn: widthIn,
      calcLengthFt: calcLengthFt,
      calcWidthFt: calcWidthFt,
      billableLength: calcLengthFt,
      billableWidth: calcWidthFt,
      billableAreaSqFt: calcLengthFt * calcWidthFt,
      billableArea: calcLengthFt * calcWidthFt,
      billablePerimeterFt: 2 * (calcLengthFt + calcWidthFt),
      billablePerimeter: 2 * (calcLengthFt + calcWidthFt),
      lengthTotal: lengthFt + lengthIn / 12,
      widthTotal: widthFt + widthIn / 12
    };
  }

  function getBillableDimensions(dims) {
    if (!dims) dims = getDimensions();
    var calcLengthFt = dims.lengthIn > 0 ? (dims.lengthFt + 1) : dims.lengthFt;
    var calcWidthFt = dims.widthIn > 0 ? (dims.widthFt + 1) : dims.widthFt;
    var billableAreaSqFt = calcLengthFt * calcWidthFt;
    var billablePerimeterFt = 2 * (calcLengthFt + calcWidthFt);
    return {
      calcLengthFt: calcLengthFt,
      calcWidthFt: calcWidthFt,
      billableLength: calcLengthFt,
      billableWidth: calcWidthFt,
      billableAreaSqFt: billableAreaSqFt,
      billableArea: billableAreaSqFt,
      billablePerimeterFt: billablePerimeterFt,
      billablePerimeter: billablePerimeterFt
    };
  }

  function getSizeLabelFromDimensions(dims) {
    if (!dims) dims = getDimensions();
    // Bestseller catalog variant matching MUST strictly check that inches are 0
    if (dims.lengthIn !== 0 || dims.widthIn !== 0) return null;

    var l = dims.lengthFt;
    var w = dims.widthFt;
    var buttons = document.querySelectorAll('.best-size[data-length][data-width]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var btnL = parseInt(btn.getAttribute('data-length'), 10);
      var btnW = parseInt(btn.getAttribute('data-width'), 10);
      if ((btnL === l && btnW === w) || (btnL === w && btnW === l)) {
        return btn.textContent.trim();
      }
    }
    return null;
  }

  function canonicalSize(sizeStr) {
    if (!sizeStr) return '';
    var match = sizeStr.match(/(\d+)\s*(?:H|ft|feet)?\s*x\s*(\d+)\s*(?:D|ft|feet)?/i);
    if (match) {
      var d1 = parseInt(match[1], 10);
      var d2 = parseInt(match[2], 10);
      if (d1 > d2) {
        return d1 + 'x' + d2 + ' ft';
      } else {
        return d2 + 'x' + d1 + ' ft';
      }
    }
    return sizeStr.trim().toLowerCase();
  }

  function findVariantOption(weightLabel, colorLabel, sizeLabel) {
    var sel = getVariantSelector();
    if (!sel || !weightLabel || !colorLabel || !sizeLabel) return null;
    var options = sel.querySelectorAll('option:not([data-custom-size])');
    var targetSize = canonicalSize(sizeLabel);
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var optSize = canonicalSize(opt.getAttribute('data-size'));
      if (opt.getAttribute('data-weight') === weightLabel &&
        opt.getAttribute('data-color') === colorLabel &&
        optSize === targetSize) {
        return opt;
      }
    }
    return null;
  }

  function setVariantSelectorValue(variantId) {
    var sel = getVariantSelector();
    if (!sel) return;
    sel.value = variantId || getCustomSizeVariantId();
  }

  function updateVariantFromDimensions() {
    var sel = getVariantSelector();
    if (!sel) return false;
    var dims = getDimensions();
    // Bestseller catalog variant matching MUST strictly check that inches are 0:
    if (dims.lengthIn !== 0 || dims.widthIn !== 0) {
      setVariantSelectorValue(getCustomSizeVariantId());
      return false;
    }
    var fastener = getSelectedFastener();
    // D-Rings and non-standard spacing are always custom fabrication
    if (!fastener || fastener.type !== 'grommets' || fastener.spacing !== '24') {
      setVariantSelectorValue(getCustomSizeVariantId());
      return false;
    }
    var sizeLabel = getSizeLabelFromDimensions(dims);
    var weightLabel = getSelectedWeightLabel();
    var colorLabel = getSelectedColorLabel();
    if (sizeLabel && weightLabel && colorLabel) {
      var opt = findVariantOption(weightLabel, colorLabel, sizeLabel);
      if (opt) {
        sel.value = opt.value;
        return true;
      }
    }
    setVariantSelectorValue(getCustomSizeVariantId());
    return false;
  }

  function getAreaAndPerimeter() {
    var bDims = getBillableDimensions();
    return {
      areaSqFt: bDims.billableAreaSqFt,
      perimeterFt: bDims.billablePerimeterFt
    };
  }

  function syncFastenerAndAccessoriesState() {
    var hasFabric = !!document.querySelector('.custom-tarps-fabric-radio:checked');
    var accSections = document.querySelectorAll('.custom-tarps-accessories');
    var fastener = getSelectedFastener();
    var webbingEl = document.getElementById('accessory-webbing');
    var webbingContainer = webbingEl ? webbingEl.closest('.custom-tarps-accessory') : null;
    var badgeEl = document.getElementById('accessory-webbing-badge');
    var accPropEl = document.getElementById('customTarpsAccessoryProperty');
    var grommetPropEl = document.getElementById('customTarpsGrommetSpacingProperty');

    if (!hasFabric) {
      accSections.forEach(function (el) {
        el.style.display = 'none';
      });
      if (webbingEl) {
        webbingEl.checked = false;
        webbingEl.disabled = true;
        webbingEl.setAttribute('aria-disabled', 'true');
      }
      if (webbingContainer) {
        webbingContainer.classList.add('is-disabled');
      }
      if (badgeEl) {
        badgeEl.style.display = 'none';
      }
      if (accPropEl) {
        accPropEl.value = '';
        accPropEl.disabled = true;
      }
      if (grommetPropEl) {
        grommetPropEl.disabled = true;
        grommetPropEl.value = '';
      }
      return;
    }

    accSections.forEach(function (el) {
      el.style.display = '';
    });

    if (fastener && fastener.type === 'drings') {
      if (webbingEl) {
        webbingEl.checked = false;
        webbingEl.disabled = true;
        webbingEl.setAttribute('aria-disabled', 'true');
      }
      if (webbingContainer) {
        webbingContainer.classList.add('is-disabled');
      }
      if (badgeEl) {
        badgeEl.style.display = 'inline';
      }
      if (accPropEl) {
        accPropEl.value = '';
        accPropEl.disabled = true;
      }
      if (grommetPropEl) {
        grommetPropEl.disabled = true;
        grommetPropEl.value = '';
      }
    } else {
      if (webbingEl) {
        webbingEl.disabled = false;
        webbingEl.removeAttribute('aria-disabled');
      }
      if (webbingContainer) {
        webbingContainer.classList.remove('is-disabled');
      }
      if (badgeEl) {
        badgeEl.style.display = 'none';
      }
      if (accPropEl) {
        if (webbingEl && webbingEl.checked) {
          accPropEl.value = '1.5" Reinforced Hem Webbing';
          accPropEl.disabled = false;
        } else {
          accPropEl.value = '';
          accPropEl.disabled = true;
        }
      }
      if (grommetPropEl) {
        if (fastener) {
          grommetPropEl.disabled = false;
          grommetPropEl.value = 'Every ' + (fastener.spacing || '24') + '"';
        } else {
          grommetPropEl.disabled = true;
          grommetPropEl.value = '';
        }
      }
    }
  }

  function calculateCustomTarpsPrice() {
    var lengthFeetEl = document.getElementById('lengthFeet');
    var lengthInchEl = document.getElementById('lengthInch');
    var widthFeetEl = document.getElementById('widthFeet');
    var widthInchEl = document.getElementById('widthInch');
    var totalPriceEl = document.getElementById('totalPrice');
    var totalSizePriceEl = document.getElementById('total-size-price');

    if (!lengthFeetEl || !widthFeetEl || !totalPriceEl) return;

    var fabricId = getSelectedFabricId();
    var submitBtn = document.querySelector('.product-form__submit');

    // Attach submit validation listener once
    var form = document.querySelector('product-form form');
    if (form && !form._customTarpsValidationAttached) {
      form._customTarpsValidationAttached = true;
      form.addEventListener('submit', function (e) {
        if (!getSelectedFabricId()) {
          e.preventDefault();
          e.stopPropagation();
          var fabricStep = document.querySelector('.custom-tarps-fabric');
          if (fabricStep) {
            fabricStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
            var firstRadio = fabricStep.querySelector('.custom-tarps-fabric-radio');
            if (firstRadio) firstRadio.focus();
          }
          return false;
        }
      }, true);
    }

    // Synchronize fastener and accessories gating, badges, and line item properties
    syncFastenerAndAccessoriesState();

    if (!fabricId) {
      totalPriceEl.textContent = '--';
      if (totalSizePriceEl) totalSizePriceEl.value = '';
      var realPriceEl = document.getElementById('real-price');
      var variantPriceEl = document.getElementById('variant-price');
      if (realPriceEl) realPriceEl.textContent = '--';
      if (variantPriceEl) variantPriceEl.textContent = '--';

      if (submitBtn) {
        submitBtn.disabled = true;
        var btnText = submitBtn.querySelector('span');
        if (btnText) {
          if (!submitBtn._originalText) submitBtn._originalText = btnText.textContent.trim();
          btnText.textContent = 'Select options';
        }
      }
      var warningEl = document.getElementById('customTarpsMinOrderWarning');
      if (warningEl) warningEl.style.display = 'none';
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = false;
      var btnText = submitBtn.querySelector('span');
      if (btnText && submitBtn._originalText) {
        btnText.textContent = submitBtn._originalText;
      }
    }

    var dims = getDimensions();
    var bDims = getBillableDimensions(dims);
    var billableAreaSqFt = bDims.billableAreaSqFt;
    var billablePerimeterFt = bDims.billablePerimeterFt;
    var fastener = getSelectedFastener();
    if (!fastener) {
      totalPriceEl.textContent = '--';
      if (totalSizePriceEl) totalSizePriceEl.value = '';
      var realPriceEl = document.getElementById('real-price');
      var variantPriceEl = document.getElementById('variant-price');
      if (realPriceEl) realPriceEl.textContent = '--';
      if (variantPriceEl) variantPriceEl.textContent = '--';
      return;
    }

    var sel = getVariantSelector();
    var isBestseller = updateVariantFromDimensions();

    var total = 0;

    if (fastener.type === 'drings') {
      var baseRate = getPricePerSqFt(getSelectedWeightId(), 'grommet24', getSelectedColorId());
      var dRingRate = (fastener.spacing === '12') ? dRings12PerFt : dRings24PerFt;
      var dRingSurcharge = billablePerimeterFt * dRingRate;
      total = (billableAreaSqFt * baseRate) + dRingSurcharge;
    } else {
      var grommetKey = getGrommetKey();
      var grommetRate = getPricePerSqFt(getSelectedWeightId(), grommetKey, getSelectedColorId());
      var accessoryTotal = 0;
      var webbingEl = document.getElementById('accessory-webbing');
      if (webbingEl && webbingEl.checked) {
        accessoryTotal += billableAreaSqFt * webbingPerSqFt;
      }

      if (isBestseller && sel && sel.value && sel.value !== getCustomSizeVariantId()) {
        var chosenOpt = sel.options[sel.selectedIndex];
        var variantPrice = chosenOpt && chosenOpt.getAttribute('data-price');
        if (variantPrice != null) {
          total = parseFloat(variantPrice) / 100 + accessoryTotal;
        } else {
          total = (billableAreaSqFt * grommetRate) + accessoryTotal;
        }
      } else {
        total = (billableAreaSqFt * grommetRate) + accessoryTotal;
      }
    }

    // Minimum Order Logic ($40 enforced on computed total)
    var isRaised = false;
    var container = document.querySelector('.custom-tarps-configurator');
    var minOrder = container ? parseFloat(container.getAttribute('data-min-order')) : 40.0;
    if (isNaN(minOrder)) minOrder = 40.0;

    if (total < minOrder) {
      total = minOrder;
      isRaised = true;
    }

    total = Math.round(total * 100) / 100;
    totalPriceEl.textContent = total.toFixed(2);
    if (totalSizePriceEl) totalSizePriceEl.value = total.toFixed(2);
    var realPriceEl = document.getElementById('real-price');
    var variantPriceEl = document.getElementById('variant-price');
    if (realPriceEl) realPriceEl.textContent = total.toFixed(2);
    if (variantPriceEl) variantPriceEl.textContent = total.toFixed(2);
    var finalPriceEls = document.querySelectorAll('.final-price');
    finalPriceEls.forEach(function (el) {
      el.textContent = total.toFixed(2);
    });

    // Update consolidated Dimensions line-item property:
    // Manufacturing cutting dimensions preserved:
    // e.g. "9' 6\" x 9' 6\"" or "10' x 10'"
    var dimPropEl = document.getElementById('customTarpsDimensionsProperty');
    if (dimPropEl && dims) {
      var lenStr = dims.lengthFt + "'" + (dims.lengthIn > 0 ? " " + dims.lengthIn + '"' : '');
      var widStr = dims.widthFt + "'" + (dims.widthIn > 0 ? " " + dims.widthIn + '"' : '');
      dimPropEl.value = lenStr + " x " + widStr;
    }

    // Toggle warning message
    var warningEl = document.getElementById('customTarpsMinOrderWarning');
    if (warningEl) {
      if (isRaised) {
        warningEl.textContent = "Note: A minimum order value of $" + minOrder.toFixed(2) + " is applied to custom orders.";
        warningEl.style.display = "block";
      } else {
        warningEl.style.display = "none";
      }
    }
  }

  function updateBestsellerSelectedState() {
    var lengthFeetEl = document.getElementById('lengthFeet');
    var widthFeetEl = document.getElementById('widthFeet');
    var lengthInchEl = document.getElementById('lengthInch');
    var widthInchEl = document.getElementById('widthInch');
    var length = lengthFeetEl ? parseInt(lengthFeetEl.value, 10) : 0;
    var width = widthFeetEl ? parseInt(widthFeetEl.value, 10) : 0;
    var lengthInch = lengthInchEl ? parseInt(lengthInchEl.value, 10) : 0;
    var widthInch = widthInchEl ? parseInt(widthInchEl.value, 10) : 0;
    var buttons = document.querySelectorAll('.custom-tarps-configurator .best-size[data-length][data-width]');
    buttons.forEach(function (btn) {
      var btnL = parseInt(btn.getAttribute('data-length'), 10);
      var btnW = parseInt(btn.getAttribute('data-width'), 10);
      if (length === btnL && width === btnW && lengthInch === 0 && widthInch === 0) {
        btn.classList.add('is-selected');
      } else {
        btn.classList.remove('is-selected');
      }
    });
  }

  function setupBestsellerButtons() {
    var buttons = document.querySelectorAll('.custom-tarps-configurator .best-size[data-length][data-width]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var length = parseInt(btn.getAttribute('data-length'), 10);
        var width = parseInt(btn.getAttribute('data-width'), 10);
        var lengthFeetEl = document.getElementById('lengthFeet');
        var widthFeetEl = document.getElementById('widthFeet');
        var lengthInchEl = document.getElementById('lengthInch');
        var widthInchEl = document.getElementById('widthInch');
        if (lengthFeetEl) lengthFeetEl.value = length;
        if (widthFeetEl) widthFeetEl.value = width;
        if (lengthInchEl) lengthInchEl.value = '0';
        if (widthInchEl) widthInchEl.value = '0';
        updateVariantFromDimensions();
        updateBestsellerSelectedState();
        calculateCustomTarpsPrice();
      });
    });
    updateBestsellerSelectedState();
  }

  function attachListeners() {
    var weightRadios = document.querySelectorAll('.custom-tarps-weight-radio');
    weightRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        updateVariantFromDimensions();
        calculateCustomTarpsPrice();
      });
    });

    var subWeightRadios = document.querySelectorAll('.custom-tarps-subweight-radio');
    subWeightRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        calculateCustomTarpsPrice();
      });
    });

    var colorRadios = document.querySelectorAll('.custom-tarps-color-radio');
    colorRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        updateVariantFromDimensions();
        calculateCustomTarpsPrice();
      });
    });

    var fastenerRadios = document.querySelectorAll('.custom-tarps-fastener-radio, .custom-tarps-grommet-radio');
    fastenerRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        updateVariantFromDimensions();
        calculateCustomTarpsPrice();
      });
    });

    var lengthFeetEl = document.getElementById('lengthFeet');
    var lengthInchEl = document.getElementById('lengthInch');
    var widthFeetEl = document.getElementById('widthFeet');
    var widthInchEl = document.getElementById('widthInch');
    function onDimensionChange() {
      updateBestsellerSelectedState();
      calculateCustomTarpsPrice();
    }
    function onDimensionKeyDown(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault();
        onDimensionChange();
        if (e.target && typeof e.target.blur === 'function') {
          e.target.blur();
        }
      }
    }
    if (lengthFeetEl) {
      lengthFeetEl.addEventListener('input', onDimensionChange);
      lengthFeetEl.addEventListener('keydown', onDimensionKeyDown);
    }
    if (lengthInchEl) {
      lengthInchEl.addEventListener('change', onDimensionChange);
      lengthInchEl.addEventListener('keydown', onDimensionKeyDown);
    }
    if (widthFeetEl) {
      widthFeetEl.addEventListener('input', onDimensionChange);
      widthFeetEl.addEventListener('keydown', onDimensionKeyDown);
    }
    if (widthInchEl) {
      widthInchEl.addEventListener('change', onDimensionChange);
      widthInchEl.addEventListener('keydown', onDimensionKeyDown);
    }

    var allDimInputs = document.querySelectorAll('.custom-tarps-dimensions input, .custom-tarps-dimensions select, .custom-price-feet input, .custom-price-feet select, .price-map input, .price-map select');
    allDimInputs.forEach(function (dimEl) {
      dimEl.addEventListener('keydown', onDimensionKeyDown);
    });

    var webbingEl = document.getElementById('accessory-webbing');
    if (webbingEl) {
      webbingEl.addEventListener('change', calculateCustomTarpsPrice);
    }
  }

  function init() {
    setVariantSelectorValue(getCustomSizeVariantId());
    setupBestsellerButtons();
    attachListeners();
    syncFastenerAndAccessoriesState();
    calculateCustomTarpsPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.customTarpsCalculatePrice = calculateCustomTarpsPrice;
  window.customTarpsGetDimensions = getDimensions;
  window.customTarpsGetBillableDimensions = getBillableDimensions;
  window.customTarpsSyncAccessories = syncFastenerAndAccessoriesState;

  // Listen for color system updates
  document.addEventListener('customTarpsImageUpdate', function (e) {
    calculateCustomTarpsPrice();
  });
})();
